// extracted by mini-css-extract-plugin
export default {"dialog_overlay":"ImageDialog_dialog_overlay__RE1CG","enlarged_image":"ImageDialog_enlarged_image__XuLU-","close_button":"ImageDialog_close_button__U4AfX"};